// Главное меню
const mainMenuRu = {
	// Надпись про то, что находитесь в такой-то школе
	youAreInSchool: 'Вы сейчас в школе',
}

export default mainMenuRu
